/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_app_analytics": "enable",
    "aws_cognito_identity_pool_id": "us-east-1:025a141b-8b0e-4920-b389-b735e0a072f8",
    "aws_cognito_region": "us-east-1",
    "aws_content_delivery": "enable",
    "aws_content_delivery_bucket": "tribevibelanding-hosting-mobilehub-917606039",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_cloudfront": "enable",
    "aws_content_delivery_cloudfront_domain": "d17uhslwvcm7t7.cloudfront.net",
    "aws_mobile_analytics_app_id": "b60884ce2476473ea362d0640a8d8420",
    "aws_mobile_analytics_app_region": "us-east-1",
    "aws_project_id": "a1d261d2-e293-41fc-952b-8520b1356f6c",
    "aws_project_name": "tribevibe-landing",
    "aws_resource_name_prefix": "tribevibelanding-mobilehub-917606039",
    "aws_sign_in_enabled": "enable",
    "aws_user_pools": "enable",
    "aws_user_pools_id": "us-east-1_93FAoxZKU",
    "aws_user_pools_mfa_type": "ON",
    "aws_user_pools_web_client_id": "7u8u84ogqt9m3injn9npveu0vs"
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js